// Stage 97: WARP — kind + swat metadata constants.
//
// The widget commits OBSERVATION → teal, QUESTION → gold, OBJECTION →
// crimson. The panel chrome stays on the operator-selected ambient
// channel; kind colors are reserved per the design handoff §3.

import type { BiteKind, SwatTag } from '../../api/gadfly';

export interface KindMeta {
  color: string;
  rgb: string;
  label: string;
  icon: string;
}

export const KIND_META: Record<BiteKind, KindMeta> = {
  OBSERVATION: {
    color: '#00CED1',
    rgb: '0, 206, 209',
    label: 'OBS',
    icon: 'observation',
  },
  QUESTION: {
    color: '#FFD700',
    rgb: '255, 215, 0',
    label: 'QST',
    icon: 'question',
  },
  OBJECTION: {
    color: '#DC143C',
    rgb: '220, 20, 60',
    label: 'OBJ',
    icon: 'objection',
  },
};

export interface SwatMeta {
  color: string;
  icon: string;
  label: string;
}

export const SWAT_META: Record<SwatTag, SwatMeta> = {
  ACCEPT: { color: '#00FF7F', icon: 'accept', label: 'ACCEPT' },
  DEFER: { color: '#FFD700', icon: 'defer', label: 'DEFER' },
  REJECT: { color: '#FF6666', icon: 'reject', label: 'REJECT' },
};

export const KIND_COLORS: Record<BiteKind, { hex: string; rgb: string }> = {
  OBSERVATION: { hex: '#00CED1', rgb: '0, 206, 209' },
  QUESTION: { hex: '#FFD700', rgb: '255, 215, 0' },
  OBJECTION: { hex: '#DC143C', rgb: '220, 20, 60' },
};
